<template>
  <section style="display:inline-flex;">
    <el-tag
      :key="tag"
      v-for="tag in dynamicTags"
      closable
      :disable-transitions="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>
    <section v-if="dynamicTags.length < maxTagCount" style="overflow:hidden;">
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="mini"
        maxlength="5"
        :placeholder="'最多'+maxTagCount+'个标签'"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-input>
      <el-button v-else class="button-new-tag" size="mini" @click="showInput"
        >+标签</el-button
      >
    </section>
  </section>
</template>

<script>
export default {
  props: {
    tags: {
      type: String,
      default: "",
    },
    maxTagCount: {
      type: Number,
      default: 3,
    },
  },
  name: "DynamicTags",
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
      this.$emit("dynamictagsInput", this.dynamicTags);
    },
  },
  mounted() {
    if (this.tags && this.tags.length > 0) {
      this.dynamicTags = this.tags.split("、");
    }
  },
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px !important;
  height: 28px;
  line-height: 28px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width:100px !important;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>